<template>
  <div v-if="firstShorthand" class="price-validation-badge-wrapper">
    <span :class="['price-validation-badge', badgeClass]">
      {{ firstShorthand }}
    </span>
    <span v-if="additionalCount > 0" :class="['price-validation-badge', badgeClass]">
      +{{ additionalCount }}
    </span>
  </div>
</template>

<script>
import Vue from 'vue';
import get from 'lodash/get';

export default Vue.extend({
  name: 'PriceValidationBadge',
  computed: {
    validations() {
      const validations = get(this, 'params.value');
      if (!Array.isArray(validations) || validations.length === 0) {
        return [];
      }
      return validations;
    },

    firstShorthand() {
      return get(this.validations, '[0].shorthand', '');
    },

    additionalCount() {
      return Math.max(this.validations.length - 1, 0);
    },

    badgeClass() {
      if (this.hasError) return '';
      if (this.hasWarning) return 'price-validation-badge--warning';
      return 'price-validation-badge--info';
    },

    hasError() {
      return this.validations.some(v => v.severity === 'error');
    },

    hasWarning() {
      return this.validations.some(v => v.severity === 'warning');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.price-validation-badge-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  width: 100%;
  height: 100%;
}

.price-validation-badge {
  padding: 0.15rem 0.4rem 0.1rem;
  border-radius: 0.2rem;
  background: $grid-view-validation-badge-color;
  color: #fff;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
}

.price-validation-badge--warning {
  background: $grid-view-validation-warning-badge-color;
  color: $pricing-black;
}

.price-validation-badge--info {
  background: $grid-view-validation-info-badge-color;
  color: #fff;
}
</style>
